import { DownloadLayoutButton } from './DownloadLayoutButton';
import { modalUtils } from '@/app/core/utils';
import {
  HasRowColor,
  OutputLayoutFieldWithDetails,
  canEmbedLayout,
  HasFieldDimensions,
  asFieldsWithDimensionsContainer,
} from '@ssar-app/domain';
// import { generateExcelFromFieldsWithDetailsAndColorAndDimensions } from '../services/program-service';
import sanitizeFilename from 'sanitize-filename';
import { saveAs } from 'file-saver';
import { Flex, Grid, GridItem, Heading, Text } from '@chakra-ui/react';

export interface OutputFileLayoutSummaryProps {
  header: string;
  programName?: string;
  outputLayoutFieldsWithDetailsAndRowColor: Record<
    string,
    HasRowColor<OutputLayoutFieldWithDetails>[]
  >;
  fullAttributesWithDetailsAndRowColor?: Record<
    string,
    HasRowColor<OutputLayoutFieldWithDetails>[]
  >;
}
export const OutputFileLayoutSummary = (
  props: OutputFileLayoutSummaryProps,
) => {
  const dataWithFieldDimensions = asFieldsWithDimensionsContainer(
    props.outputLayoutFieldsWithDetailsAndRowColor.outputLayout || [],
  ).fields;
  const inputFieldsWithDimensions = asFieldsWithDimensionsContainer(
    props.outputLayoutFieldsWithDetailsAndRowColor.inputLayout || [],
  ).fields;
  const fullAttributesDataWithFieldDimensions: Record<
    string,
    HasFieldDimensions<HasRowColor<OutputLayoutFieldWithDetails>>[]
  > = {};
  Object.keys(props.fullAttributesWithDetailsAndRowColor || {}).map((fa) => {
    fullAttributesDataWithFieldDimensions[fa] = asFieldsWithDimensionsContainer(
      props.fullAttributesWithDetailsAndRowColor?.[fa] || [],
    ).fields;
  });
  const handleDownload = async (): Promise<void> => {
    try {
      const excelService = await import('../common/services/excel-service');
      await excelService
        .generateExcelFromFieldsWithDetailsAndColorAndDimensions(
          {
            outputLayoutFields: dataWithFieldDimensions,
            inputLayoutFields: inputFieldsWithDimensions,
            fullAttributeFields: fullAttributesDataWithFieldDimensions,
          },
          props.header,
        )
        .then((workbook) =>
          workbook.xlsx.writeBuffer().then((buf) => {
            saveAs(
              new Blob([buf]),
              `${sanitizeFilename(
                props.programName || 'OutputLayoutSummary',
              )}.xlsx`,
            );
          }),
        );
    } catch (err) {
      modalUtils.showError(err);
    }
  };
  return (
    <>
      <Heading
        as={'h3'}
        textAlign={'center'}
        color={'#1d4f91'}
        marginTop={8}
        fontSize={'sm'}
        fontFamily={'Roboto'}
        fontWeight={'normal'}
      >
        {props.header}
      </Heading>
      {dataWithFieldDimensions.length > 0 ? (
        <>
          <Flex justifyContent={canEmbedLayout ? 'center' : 'end'} mt={2}>
            <DownloadLayoutButton
              onDownload={handleDownload}
              title={props.header}
            />
          </Flex>
          {!canEmbedLayout && (
            <Grid
              templateColumns='repeat(9, 1fr)'
              gap={0}
              border={'1px'}
              mt={2}
            >
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Field#</strong>
              </GridItem>
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Source</strong>
              </GridItem>
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Field Name</strong>
              </GridItem>
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Client Header</strong>
              </GridItem>
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Length</strong>
              </GridItem>
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Start</strong>
              </GridItem>
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Description</strong>
              </GridItem>
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Valid Values</strong>
              </GridItem>
              <GridItem textAlign={'center'} border={'1px'}>
                <strong>Default/Exclusion Values</strong>
              </GridItem>
              {dataWithFieldDimensions.map((item, index) => {
                return (
                  <>
                    <GridItem
                      backgroundColor={item?.rowColor}
                      border={'1px'}
                      textAlign={'center'}
                    >
                      {index + 1}
                    </GridItem>
                    <GridItem backgroundColor={item?.rowColor} border={'1px'}>
                      {item?.source || ''}
                    </GridItem>
                    <GridItem backgroundColor={item?.rowColor} border={'1px'}>
                      {item?.name || ''}
                    </GridItem>
                    <GridItem backgroundColor={item?.rowColor} border={'1px'}>
                      {item?.headerName || ''}
                    </GridItem>
                    <GridItem
                      backgroundColor={item?.rowColor}
                      border={'1px'}
                      textAlign={'center'}
                    >
                      {item?.fieldLength || ''}
                    </GridItem>
                    <GridItem
                      backgroundColor={item?.rowColor}
                      border={'1px'}
                      textAlign={'center'}
                    >
                      {item?.begin || ''}
                    </GridItem>
                    <GridItem
                      backgroundColor={item?.rowColor}
                      border={'1px'}
                      textAlign={'center'}
                    >
                      {item?.description || ''}
                    </GridItem>
                    <GridItem
                      backgroundColor={item?.rowColor}
                      border={'1px'}
                      textAlign={'center'}
                    >
                      {item?.validValues || ''}
                    </GridItem>
                    <GridItem
                      backgroundColor={item?.rowColor}
                      border={'1px'}
                      textAlign={'center'}
                    >
                      {item?.defaultValues || ''}
                    </GridItem>
                  </>
                );
              })}
            </Grid>
          )}
        </>
      ) : (
        <Text>No output layout fields selected for this program.</Text>
      )}
    </>
  );
};
